let wrapper;

window.addEventListener('load', () => {
	wrapper = document.querySelector('.o-training--enroll');

	if(wrapper) {
		setMoment()
		loadMore()
	}
})


const setMoment = () => {
	const moments = wrapper.querySelector('.o-moments').querySelectorAll('.o-moments__single')
	const form = wrapper.querySelector('.o-form')

	moments.forEach(moment => {
		moment.addEventListener('click', () => {
			toggleActiveClass(moments, moment)
			form.querySelector('select').selectedIndex = moment.getAttribute('data-form-selectoptionid')
		})
	});
}

const loadMore = () => {
	const loadMoreButton = wrapper.querySelector('.load-more')
	loadMoreButton.addEventListener('click', () => {
		wrapper.classList.add('show-all')
	})
}

const toggleActiveClass = (moments, moment) => {
	moments.forEach(el => {
		el.classList.remove('is-current')
	});
	moment.classList.add('is-current')
}



// WEBPACK FOOTER //
// ./js/app/enroll.js